import { EditorModes, PcbNodeTypes, ReviewType } from "@buildwithflux/models";
import { reduce } from "lodash";
import { isCloseTo, ToleranceCornerRadius, TraceCorners } from "../../pcb";
import { getProblemTypeKeyFromReviewType } from "../types";
export class TraceCornerRadiusValidator {
    reviewType = ReviewType.DesignRuleCheckTraceCornerRadius;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    defaultHidden = true;
    async checkForProblems(inputs) {
        const checkVertexViolation = (node, vertex) => {
            const radius = TraceCorners.computeRadius(vertex, node, inputs.pcbLayoutNodes, inputs.pcbTracingGraph.getGraph());
            if (radius === undefined) {
                return false;
            }
            if (isCloseTo(radius, node.bakedRules.traceCornerRadiusMinimum, ToleranceCornerRadius)) {
                // Actual radius value is often close to traceCornerRadiusMinimum but due to numerical errors, a test such
                // as `radius < node.bakedRules.traceCornerRadiusMinimum` can return false positives. If the radius is
                // within a range of tolerance it's considered equal and a violation is not reported.
                return false;
            }
            else {
                // If we're here, then the values a sufficiently different so regular logic is okay to use
                return radius < node.bakedRules.traceCornerRadiusMinimum;
            }
        };
        const foundProblems = reduce(inputs.pcbLayoutNodes, (problems, node) => {
            if (node.type !== PcbNodeTypes.routeSegment) {
                return problems;
            }
            if (checkVertexViolation(node, "start") || checkVertexViolation(node, "end")) {
                problems.push({
                    problemTypeKey: this.problemTypeKey,
                    key: `${this.problemTypeKey}_${node.uid}`,
                    affectedItems: [{ type: "pcbLayoutNode", uid: node.uid }],
                    affectedViews: [EditorModes.pcb],
                });
            }
            return problems;
        }, []);
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems,
        };
    }
}
//# sourceMappingURL=TraceCornerRadiusValidator.js.map